<template>
    <div class="">
        <CarouselLarge />
    </div>
    <!-- <div class="d-block d-md-none"> 
        <Carousel />
    </div> -->
    <main id="main" />

    <!-- ======= About Section ======= -->
    <section id="About" class="About">
        <div class="container section-title text-start" data-aos="zoom-out">
            <h2>About</h2>
            <p>What we do</p>
        </div>
        <About />
    </section>
    <!-- End About Section -->

    <!-- ======= Video Section ======= -->
    <section id="About" class="About">
        <div class="container section-title text-start" data-aos="zoom-out">
            <h2>Impact</h2>
            <p>Impact Stories</p>
        </div>
        <Videos />
    </section>
    <!-- End Video Section -->

    <!-- ======= Products Section ======= -->
    <section id="Products" class="Products">
        <div class="container section-title text-start" data-aos="zoom-out">
            <h2>Products</h2>
            <p>What we offer</p>
        </div>
        <Products />
    </section>
    <!-- End Products Section -->

    <!-- ======= Projects Section ======= -->
    <section id="Projects" class="Projects">
        <div class="container section-title text-start" data-aos="zoom-out">
            <h2>Projects</h2>
            <p>We are transforming lives</p>
        </div>
        <Projects />
    </section>
    <!-- End Projects Section -->

    <!-- ======= Impact Section ======= -->
    <section id="impact" class="impact">
        <Impact />
    </section>
    <!-- End Impact Section -->

    <!-- ======= Aricles Section ======= -->
    <section id="Articles" class="Articles">
        <div class="container section-title text-start" data-aos="zoom-out">
            <h2>Articles</h2>
            <p>What's happening</p>
        </div>
        <Articles />
    </section>
    <!-- End Articles Section -->

    <!-- ======= Contact Section ======= -->
    <section id="Contact" class="Contact">
        <div class="container section-title text-start" data-aos="zoom-out">
            <h2>Contact</h2>
            <p>Let's Get Talking</p>
        </div>
        <Contact />
    </section>
    <!-- End Contact Section -->

    <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header bg-success text-white">
                <h1 class="modal-title fs-5" id="myModalLabel">Welcome to Agro Innova 👋</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="text-start">
                    <h3>Explore Our Ongoing Projects 🚀</h3>
                    <p>👀 Take a look at our ongoing projects and apply today!</p>
                    <ul>
                        <li><p> 🐥🐓🌽 <strong>FILMA - Poultry Success Initiative</strong></p></li>
                        <li><p>🐥🐓 <strong>PIAA - Poultry Farm to Fork Initiative</strong></p></li>
                        <li><p>🐥🐓🌽🌾 <strong>BIA - Agro Innova Poultry and Grains Project</strong> </p></li>
                    </ul>
                </div>
                <div class="text-start">
                    <small>
                        <em>🛑 Note: Click on the "Apply for Project" button for more information.</em>
                    </small>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Go to Home</button>
                <button type="button" class="btn btn-success" data-bs-dismiss="modal" @click="goToProject">Apply for Project</button>
            </div>
            </div>
        </div>
    </div>

</template>

<script>
import Carousel from '@/components/carousel/Carousel.vue';
import CarouselLarge from '@/components/carousel/Carousel-large.vue';
import Products from '@/components/products/Products.vue';
import About from '../../components/about/About.vue';
import Impact from '@/components/impact/impact.vue';
import Articles from '@/components/articles/Articles.vue';
import Contact from '@/components/contact/contact.vue';
import Videos from '@/components/videos/Videos.vue';
import Projects from '@/components/projects/Projects.vue';

import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default {
    name: 'Home',
    components: {
        Carousel,
        CarouselLarge,
        Products,
        Projects,
        About,
        Impact,
        Articles,
        Contact,
        Videos
    },
    mounted() {
        this.$nextTick(() => {
        this.openModal();
        });
    },
    methods: {
        openModal() {
        var modal = new bootstrap.Modal(document.getElementById('myModal'));
        modal.show();
        },
        goToProject() {

            window.location.href = "#Projects";
        }
    }
}
</script>

<style scoped>

/*--------------------------------------------------------------
# Section
--------------------------------------------------------------*/
section {
    margin: 70px 0 70px 0;
    overflow: hidden;
}

.section-title {
    padding-bottom: 40px;
}

.section-title h2 {
    font-size: 14px;
    font-weight: 500;
    padding: 0;
    margin: 0 0 5px 0;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #aaaaaa;
}

.section-title h2::after {
    content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #3db49d;
    margin: 4px 10px;
}

.section-title p {
    margin: 0;
    margin: 0;
    line-height: normal;
    font-size: 36px;
    font-weight: 700;
    text-transform: uppercase;
    color: #2a2c39;
}
</style>